import { MapPointAPI } from '../../../api/datamanager/MapPointAPI';

export class MapPointsCommand {
    getAll(edition, providerId, successCallback, errorCallback) {
        const apiResult = MapPointAPI.list(edition.network, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Pontos Notáveis");
            }
        });
    }

    getAllTransportAuthority(successCallback, errorCallback) {
        const apiResult = MapPointAPI.listTransportAuthority();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Pontos Notáveis");
            }
        });
    }

    save(edition, mapPoint, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === mapPoint.id || 0 === mapPoint.id) {
            apiResult = MapPointAPI.create(edition.network, mapPoint);
            successMessage = "Ponto Notável criado com sucesso";
        }
        else {
            apiResult = MapPointAPI.update(edition.network, mapPoint.id, mapPoint);
            successMessage = "Ponto Notável editado com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    saveTransportAuthority(mapPoint, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if(0 === mapPoint.id) {
            apiResult = MapPointAPI.createTransportAuthority(mapPoint);
            successMessage = "Ponto Notável criado com sucesso";
        }
        else {
            apiResult = MapPointAPI.updateTransportAuthority(mapPoint.id, mapPoint);
            successMessage = "Ponto Notável editado com sucesso";
        }
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback(successMessage);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, mapPointId, successCallback, errorCallback) {
        const apiResult = MapPointAPI.delete(edition.network, mapPointId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Ponto Notável eliminado com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    deleteTransportAuthority(mapPointId, successCallback, errorCallback) {
        const apiResult = MapPointAPI.deleteTransportAuthority(mapPointId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                successCallback("Ponto Notável eliminado com sucesso");
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/MapPointsCommand.js